'use client';

import Image from 'next/image';
import { useState } from 'react';
import { DEFAULT_IMAGE, DEFAULT_IMAGE_BASE64 } from 'constants/index';
import * as El from './OrganizerCard.css';

interface LogoUrls {
  original?: string;
  lg?: string;
  xs?: string;
}

interface OrganizerCardProps {
  logo: LogoUrls;
  name: string;
  href?: string;
  sectionPosition?: string;
  dataCreative?: string;
  loadingImage?: 'lazy' | 'eager';
}

function OrganizerCard({
  logo = { original: '' },
  name = '',
  href = '#',
  sectionPosition = '',
  dataCreative = '',
  loadingImage = 'eager'
}: OrganizerCardProps) {
  const [isLoading, setIsLoading] = useState(true);
  const isExternalUrl = /^https?:\/\//i.test(href || '');
  return (
    <a
      className={`${El.cardContainer} sympla-organizer-card`}
      href={href}
      title={name}
      target={isExternalUrl ? '_blank' : '_self'}
      rel={isExternalUrl ? 'noopener noreferrer' : undefined}
      aria-label={name}
      data-name={name}
      data-position={sectionPosition}
      data-creative={dataCreative}
    >
      <div className={El.contentWrapper}>
        <div className={El.imageContainer}>
          <Image
            className={El.organizerImage[isLoading ? 'true' : 'false']}
            alt={`Logo ${name}`}
            src={logo.lg || logo.original || logo.xs || DEFAULT_IMAGE}
            width={140}
            height={140}
            loading={loadingImage}
            priority={loadingImage === 'eager'}
            onLoad={() => {
              setIsLoading(false);
            }}
            placeholder="blur"
            blurDataURL={DEFAULT_IMAGE_BASE64}
          />
        </div>

        <div className={El.organizerInfo}>
          <div className={El.nameWrapper}>
            <div className={El.organizerName}>{name}</div>
          </div>
        </div>
      </div>
    </a>
  );
}

export default OrganizerCard;
